module.exports = __webpack_public_path__ + "img/banner.ebabb59b.jpg";